import { z } from 'zod/v4';

export const assetsImportResultsSchema = z.object({
  status: z.number(),
  error: z
    .object({
      errorDetails: z
        .array(
          z.object({
            errorCode: z.number(),
            externalIds: z.array(z.string()),
          })
        )
        .nullable()
        .optional(),
    })
    .nullable()
    .optional(),
});
